import WINDOW from "../../../../utils/window";

/**
 *
 * @param {BoundsProps} bounds
 * @returns {Map<"corner" | "x-side" | "y-side", Number>}
 */
const getMaxSide = (bounds) => {
  const width = /** @type {Number} */ (WINDOW.get("width"));
  const height = /** @type {Number} */ (WINDOW.get("height"));
  const centerX = /** @type {Number} */ (bounds.get("center-x"));
  const centerY = /** @type {Number} */ (bounds.get("center-y"));

  const sideX = Math.pow(width - centerX, 2);
  const a = Math.pow(centerX, 2);
  const b = Math.pow(centerY, 2);
  const lt = Math.sqrt(a + b);
  const lb = Math.sqrt(a + Math.pow(height - centerY, 2));
  const rt = Math.sqrt(sideX + Math.pow(centerY, 2));
  const rb = Math.sqrt(sideX + Math.pow(height - centerY, 2));
  const corner = Math.max(...[lt, lb, rt, rb]);

  const ls = centerX;
  const rs = width - centerX;
  const ts = centerY;
  const bs = height - centerY;
  const xSide = Math.max(...[ls, rs]);
  const ySide = Math.max(...[ts, bs]);

  return new Map([
    ["corner", corner],
    ["x-side", xSide],
    ["y-side", ySide],
  ]);
};

export default getMaxSide;
